module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/favicon.ico
// module id = 1772
// module chunks = 55